export default __webpack_public_path__ + "static/media/51.d18eeb99.png";